import React, { useState } from 'react';

import { Resource } from '../../../../common/constants/resource';
import styles from './mvr.module.scss';

/** Collapsible "Miscellaneous Info" panel showing the provider free-text message. */
export const MVRMiscPanel = ({
  miscellaneous,
}: {
  miscellaneous?: string;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.miscSection}>
      <button
        type="button"
        className={styles.miscHeader}
        aria-expanded={open}
        onClick={() => setOpen(prev => !prev)}
      >
        <span className={styles.sectionTitle}>
          {Resource.MVR_LICENSE_MISCELLANEOUS}
        </span>
        <span className={`${styles.miscChevron} ${open ? styles.open : ''}`}>
          ▼
        </span>
      </button>
      {open && (
        <div className={styles.miscBody}>
          <p className={styles.miscVerbose}>{miscellaneous}</p>
        </div>
      )}
    </div>
  );
};
